import styled from '@emotion/styled'

export const StyleWrapper = styled.div`
  display: flex;
  background: ${(props: any) => props.theme.colors.white};
  height: calc(100dvh - 135px);
  border-radius: 12px;
`
